import BaseMode from './BaseMode';
import Effect from '../Effect/EffectLine';
import Layer from '../Layer/LineModeLayer';
import { DEFAULT_LINE_OPTION } from '../../renderOption';
import { SHAP_TYPE, FUN_TYPE, EFFECT_TAG, LAMP_LAYOUT_SERVICE_MODE, LINE_LAYOUT_SERVICE_MODE, LINE_DIR, EFFECT_LEVEL } from '../../enums/index';
import { calDivideEquallyByRowListInfo, fixedNumber } from '../../utils/common';
import { getRelationWithPointer } from '../../utils/line'; 


/**
 * 初始化data数据
 * @returns 
 */
function getDefaultData () {
  return {
    config: {},
    rendrenOption: {},
    content: null,
    stage: null,
    canvasContent: null,
    curDrawLayerId: 0,
    drawLayer: new Map(),
    isPointerMove: false,
    stageSize: { with: 0, height: 0 },
    curMovePointer: {
      startX: 0,
      startY: 0,
      node: null
    }
  };
}

/**
 * 直角线绘制组件
 */
class TemplateMode extends BaseMode {
  constructor(props) {
    super(props);

    this.init(props);
  }

  data = getDefaultData();

  init = (props = {}) => {
    this.initProps(props);

    this.data.rendrenOption = this.mergeDrawOption(
      props.rendrenOption,
      DEFAULT_LINE_OPTION
    );

    if (!props.initData) {
      // 首次创建
      this.createDrawLayer(props.stageMapId || 0);
    } else {
      // 根据储存数据回显
      this.revertDrawLayer(props);
    }
  }
  
  // 恢复回显数据 用于保存过历史数据
  revertDrawLayer(props) {
    const initData = props.initData;
      const activeId = props.stageMapId || 0;
      const historyBgSize = props.historyBgSize;
      const bgSize = props.bgSize;
      // const historyStageSize = props.historyStageSize;
      // const stageSize = props.stageSize;

      let ratio = 1;

      if (historyBgSize && historyBgSize.width) {
        ratio = Number((bgSize.width / historyBgSize.width).toFixed(2));
      }

    Object.entries(initData).forEach(([ id, drawLayerData = {} ]) => {
      const {
        p: pointerRenderData = {},
        l: lampRenderData = {}
      } = drawLayerData;

      // 创建挂载物图层 false不直接切当前图层【 阻止直接做渲染 】
      this.createDrawLayer(id, false);

      // 切到当前图层
      this.data.curDrawLayerId = id;

      const { m: pointerMode, dl: pointerList } = pointerRenderData;
      const { m: lampMode, l: lampList, c: lampCount } = lampRenderData;

      if (
        pointerMode === LINE_LAYOUT_SERVICE_MODE.LINK &&
        Array.isArray(pointerList)
      ) {
        pointerList.forEach(pointer => {
          const { f: funType, s: shapType, r: serviceRenderData } = pointer;

          // 创建节点 但不做渲染
          this.createNewPointer(
            {  offsetX: serviceRenderData.x * ratio, offsetY: serviceRenderData.y * ratio},
            false
          );
        })
      }

      // 平均模式 按每根线均值切分灯
      if (
        lampMode === LAMP_LAYOUT_SERVICE_MODE.SIMGLE_LINE_AVERAGE &&
        Array.isArray(lampList)
      ) {
        this.setLampInfo(lampList);
        this.addLamp(lampCount, false);
      }
    });

    // curDrawLayerId不变化的话不会触发render高亮
    this.data.curDrawLayerId = -1;

    // 激活首个图层 将其余的变暗淡
    this.setCurLineLayerIndexWithAllOpacity(activeId);
    
    // 对所有挂载物进行一次性渲染
    this.renderAllLayer();
  }

  /**
   * 创建新的挂载物
   * @param {*} mapId 
   * @param {*} isSetCurLineLayer 
   */
  createDrawLayer(mapId, isSetCurLineLayer = true) { 
    // Layer {
    //   layer: new window.Konva.Layer({}),
    //   group: new window.Konva.Group({}),
    //   // 双向链表形式 点 -> 线 -> 点
    //   lineNodeQuene: new CircleLineNodeQueue({
    //     render: this.render // flush副作用后渲染函数
    //   }),
    //   // 双向链表形式 灯 -> 灯
    //   lampNodeQueue: new CircleNodeQueue({
    //     render: this.render
    //   }),
    // };
    const drawLayer = new Layer({
      stage: this.data.stage,
      mapId
    });

    this.data.drawLayer.set(mapId, drawLayer)
    this.data.stage.add(drawLayer.stateNode);

    // 初始化创建
    if (isSetCurLineLayer && mapId !== 0) this.setCurLineLayerIndex(mapId);

    drawLayer.stateNode.addEventListener('click', () => {
      this.setCurLineLayerIndex(mapId);

      if (this.data.onActive) this.data.onActive(mapId);
    })

    return drawLayer;
  }

  // 新增点以及连线
  createNewPointer(e, isRender = true) {
    const rendrenOption = this.data.rendrenOption; // 绘图配置
    const drawLayer = this.getCurDrawLayer(); // 当前图层
    const { lampNodeQueue, lineNodeQuene } = drawLayer;
    const { lastCircle, lastLine } = lineNodeQuene.getLastLineAndCircle(); // 上一次点

    const { offsetX, offsetY } = e || {};

    const insertPointer = this.createCircle({
      x: offsetX,
      y: offsetY,
    }, FUN_TYPE.POINTER, rendrenOption.pointer);

    // DrawLayer调用add有推入group的功能 用于z-index展示
    drawLayer.add(insertPointer);

    if (lastCircle) {
      const { x: startX, y: startY } = lastCircle.renderData;
      const startSize = lastLine ? lastLine.renderData.endSize : 0;
      // 创建直角链接的线
      const insertLine = this.createSingleLine({
        startX,
        startY,
        endX: offsetX,
        endY: offsetY,
        startSize,
      }, FUN_TYPE.LINE, rendrenOption.line);

      drawLayer.add(insertLine);

      // 必须先推线 推入双向链表
      lineNodeQuene.push(insertLine);
    }
    // 必须后推点 推入双向链表
    lineNodeQuene.push(insertPointer);

    // insertPointer.stateNode.on('mousedown', this.handlerPointerMoveStart.bind(this, insertPointer));

    if (!!lampNodeQueue.count) {
      // 有灯的情况 等添加完灯一起渲染
      this.addLamp(lampNodeQueue.count, isRender);
    } else {
      // 没灯直接渲染
      isRender && this.render();
    }
  }

  // 获取当前点应该落在哪个坐标 (直角坐标xy)
  getCurPointerPos(offsetX, offsetY) {
    const { lineNodeQuene } = this.getCurDrawLayer();
    const { lastCircle, lastLine } = lineNodeQuene.getLastLineAndCircle();

    // 首次点击
    if (!lastCircle) return { x: offsetX, y: offsetY };

    const { x, y } = lastCircle.stateNode.position();

    // 第三次点击及之后 所有线之后所有点击按直角计算
    if (lastLine) {
      const { direction } = lastLine.renderData;
      
      // 线方向  ROWLR 横向 左 -> 右 ROWRL 横向 右 -> 左 COLTB 纵向 上 -> 下 COLBT 纵向 下 -> 上
      if ([ LINE_DIR.ROWLR, LINE_DIR.ROWRL ].includes(direction)) {
        // 横向 本次走纵向
        return {
          x,
          y: offsetY
        }
      } else {
        // 纵向 本次走横向
        return {
          x: offsetX,
          y
        }
      }
    }

    // 第二次点击以偏移量计算
    const gapX = Math.abs(x - offsetX);
    const gapY = Math.abs(y - offsetY);

    if (gapX > gapY) {
      return {
        x: offsetX,
        y
      }
    } else {
      return {
        x,
        y: offsetY
      }
    }
  }


  getLampXyByCurLayerInArray = (lampInfo) => {
    const { lineNodeQuene } = this.getCurDrawLayer();
    const { nodeList } = lineNodeQuene.getMainLineByLongest(lampInfo.length);

    let lampData = null;
    let lastData = null;

    nodeList.forEach((curNode, curNodeIndex) => {
      const lampCount = Number(lampInfo[curNodeIndex]) || 0;
      
      const curLineSize = curNode.renderData.size;        
      const singleLampSize = lampCount === 1 ? curLineSize / 2 : curLineSize / (lampCount - 1);

      for (let i = 0; i < lampCount; i++) {
        let curData = null;
        // 一个灯位直接布在中间 线左右端点本身各占一个灯位
        const index = lampCount === 1 ? i + 1 : i;
        const { startX, startY, startSize, direction } = curNode.renderData || {};
        const moveSize = singleLampSize  * index;
    
        switch (direction) {
          // 横向 左 -> 右 
          case LINE_DIR.ROWLR:
            curData = {
              x: startX + moveSize,
              y: startY
            };
            break;
          // 横向 右 -> 左
          case LINE_DIR.ROWRL:
            curData = {
              x: startX - moveSize,
              y: startY
            };
            break;
          // 纵向 上 -> 下
          case LINE_DIR.COLTB:
            curData = {
              x: startX,
              y: startY + moveSize,
            };
            break;
          // 纵向 下 -> 上
          case LINE_DIR.COLBT:
            curData = {
              x: startX,
              y: startY - moveSize
            };
            break;
        }
  
        if (!lampData) {
          lampData = curData;
        } else {
          lastData.next = curData;
        }
  
        lastData = curData;
      }
    })

   return lampData;
  }

  // 获取每个灯的点位
  getLampXyByCurLayer = (count) => {
    const { lineNodeQuene, lampNodeQueue } = this.getCurDrawLayer();
    const lampCount = Number(count);

    if (!Array.isArray(lampNodeQueue.circleInfoList)) {
      throw new Error('模版数据错误');
    }
    
    return this.getLampXyByCurLayerInArray(lampNodeQueue.circleInfoList)
  }

  // 针对点前或后的点和线打上effectTag副作用 用于更新renderData以及更新图状态
  createEffectOnNode({ siblingLine, siblingPointer, siblingSiblingLine, siblingSiblingPointer, currentX, currentY, type }) {
    const { startX } = this.data.curMovePointer; // 当前移动的点x
    const isNext = type === 'next';

    if (siblingPointer) {      
      const { startMovePosition } = siblingPointer.renderData; // 边上的点 【type:next 是链表右侧 pre 是链表左侧】
      const relation = getRelationWithPointer(startX, startMovePosition.x);

      console.log('relation relation', relation);
      // LINE_DIR.ROW 横向
      const x = relation === LINE_DIR.ROW ? startMovePosition.x : currentX;
      const y = relation === LINE_DIR.ROW ? currentY : startMovePosition.y

      // 推入点定位的副作用
      siblingPointer.flags = siblingPointer.flags | EFFECT_TAG.POSITION;
      siblingPointer.effects.push(new Effect({
        flag: EFFECT_TAG.POSITION,
        payload: {
          x,
          y
        }
      }));

      // 推入线定位的副作用
      siblingLine.flags = siblingLine.flags | EFFECT_TAG.POINTS;
      siblingLine.effects.push(new Effect({
        flag: EFFECT_TAG.POINTS,
        // 链表往右侧走的情况当前点为起点 siblingPointer为终点 反之倒转
        payload: {
          startX: isNext ? currentX : x,
          startY: isNext ? currentY : y,
          endX: isNext ? x : currentX,
          endY: isNext ? y : currentY
        }
      }));

      // 隔壁再隔壁的线变化
      if (siblingSiblingLine) {
        const { x: siblingSiblingX, y: siblingSiblingY } = siblingSiblingPointer.stateNode.position();

        siblingSiblingLine.flags = siblingSiblingLine.flags | EFFECT_TAG.POINTS;
        siblingSiblingLine.effects.push(new Effect({
          flag: EFFECT_TAG.POINTS,
          // 链表往右侧走的情况兄弟点为起点 兄弟兄弟节点为终点 反之倒转
          payload: {
            startX: isNext ? x : siblingSiblingX,
            startY: isNext ? y : siblingSiblingY, 
            endX: isNext ? siblingSiblingX : x,
            endY: isNext ? siblingSiblingY : y
          }
        }));
      }
    }
  }

  // 获取所有灯位数据
  getAllLampPosition(mapId) {
    const drawLayer = this.getCurDrawLayer(mapId);
    const { lampNodeQueue } = drawLayer;

    const lampPositionList = [];
    
    let curNode = lampNodeQueue.firstNode;

    while (curNode) {
      lampPositionList.push({
        x: curNode.renderData.x,
        y: curNode.renderData.y,
      });

      curNode = curNode.next;
    }

    return lampPositionList;
  }


  // 获取保存的数据 用于上传服务端
  // 此处由于以字符串形式储存 所以为节约落库表的字段名以精简为主
  // 此处只储存点的数据 并不记录线和灯的坐标 服务下发后 根据mode恢复
  getSaveData = () => {
    const drawLayerData = {};

    this.data.drawLayer.forEach((drawLayer, id) => {
      const circleInfoList = drawLayer.lampNodeQueue.circleInfoList;
      const mode = Array.isArray(circleInfoList) && circleInfoList.length > 1 ? LAMP_LAYOUT_SERVICE_MODE.SIMGLE_LINE_AVERAGE : LAMP_LAYOUT_SERVICE_MODE.AVERAGE;
      const data = {
        // pointerrDataQuene
        p: {
          // dataList
          dl: [],
          // 
          m: LINE_LAYOUT_SERVICE_MODE.LINK
        },
        // lampRenderDataQueue
        l: {
          // mode
          m: mode,
          // 数量
          c: drawLayer.lampNodeQueue.count,
          // 没跟灯带上的位置
          l: circleInfoList
        }
      }

      // 储存点线的数据 
      let curNode = drawLayer.lineNodeQuene.firstNode;

      while (curNode) {
        // LINE_LAYOUT_SERVICE_MODE.LINK模式 只储存点信息 线信息加载的时候恢复 
        if (curNode.shapeType === SHAP_TYPE.CIRCLE) {
          const nodeInfo = {
            // shapType
            s: curNode.shapeType,
            // funType
            f: curNode.funType,
            // renderData
            r: curNode.getSaveRenderData() || {}
          }
          
          data.p.dl.push(nodeInfo);
        }

        curNode = curNode.next;
      }
  
      // 由于走过一次JSON.stringify lastNode 和 firstNode 内存地址脱钩 没必要存
      delete data.p.l;
      drawLayerData[id] = data;
    })

    return drawLayerData;
  }
}

export default TemplateMode;